/**
 * Enlace de WhatsApp a partir de un número del CMS.
 *
 * Único sitio donde se arma un `wa.me` en el landing: estaba copiado literal en
 * `ContactFab.tsx` y `Assistant.tsx`, y el pie iba a ser la tercera copia (goal
 * portal-correcciones-3). Los números del CMS se escriben a mano
 * ("+53 5350 0001"), así que se normalizan a dígitos.
 */

/** Deja solo los dígitos: el CMS trae espacios, guiones y `+`. */
export const digitsOnly = (value: string): string => value.replace(/\D/g, '')

/**
 * `https://wa.me/<dígitos>` con el mensaje opcional ya codificado.
 *
 * No valida: quien lo pinte debe comprobar antes que el número tiene dígitos
 * (`digitsOnly`), porque un `wa.me/` sin número es justo el enlace que no lleva
 * a ninguna parte.
 */
export function waLink(phone: string, message?: string): string {
  return `https://wa.me/${digitsOnly(phone)}${message ? `?text=${encodeURIComponent(message)}` : ''}`
}
